<template>
  <PanelV2
    type="w9"
    mode="simple"
    showGoBack
  >
    <template v-slot:content-solt>
      <span class="title">Set up your new password</span>
      <el-form :model="formData" ref="password" :rules="formRules">
        <el-form-item label="New Password" prop="mchPassword">
          <NewPassword v-model="formData.mchPassword" />
        </el-form-item>
        <el-form-item label="Confirm Password" prop="confirmPassword" >
          <el-input :type="inputType" v-model="formData.confirmPassword" placeholder="Confirm Password" maxlength="16" autocomplete="new-password">
            <template slot="suffix">
                <img v-if="isShow" @click="changeShow" class="right_icon" src="@/assets/pc/mask-outline.svg" />
                <img v-if="!isShow" @click="changeShow" class="right_icon" src="@/assets/pc/Icon - Unmask@3x.png" />
            </template>
          </el-input>
        </el-form-item>
      </el-form>

      <el-button type="primary" @click="next()" >Submit</el-button>
    </template>
  </PanelV2>
</template>

<script>
  import API from "@/api";
  import MD5 from '@/plugins/crypto-md5.js'
  export default {
    name: 'ChangePassword',
    pRouter: 'VerifyOtp',
    data() {
      return {
        formData: {
          mchPassword: '',
          confirmPassword: ''
        },
        formRules: {
          mchPassword:[],
          confirmPassword: []
        },
        isShow: true,
        inputType: 'password'
      }
    },
    created() {
      window.loadI18NData('en', () => {});

      this.formRules['mchPassword'].push({
        validator: this.validatePass,
        trigger: 'change'
      });
      this.formRules['confirmPassword'].push({
        validator: this.validatePass2,
        trigger: 'change'
      });
    },
    methods: {
      // 验证密码
      validatePass(rule, value, callback) {
        const rules = /[`~!@#$%^&*()_\-+=<>?:"{}|,.;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、/]/im
        if (!(/[a-z]/.test(value) && /[A-Z]/.test(value) && /[0-9]/.test(value) && rules.test(value)) || (value.length < 8 || value.length > 16)) {
          callback(new Error(`Enter New Password`));
        } else {
          callback();
        }
      },
      // 验证密码 一致性校验
      validatePass2(rule, value, callback) {
        if (value === '') {
          callback(new Error(`Confirm your password`));
        } else if (value !== this.formData.mchPassword) {
          callback(new Error('Passwords do not match.'));
        } else {
          callback();
        }
      },
      changeShow() {
        this.isShow = !this.isShow
        if (this.isShow) {
          this.inputType = 'password'
        } else {
          this.inputType = 'text'
        }
      },
      next() {
        const email = sessionStorage.getItem('email')
        const code = sessionStorage.getItem('code')
        this.$refs.password.validate((valid) => {
          if(valid) {
            API.modifyPassword({
              email,
              code,
              newPassword: MD5(String(this.formData.confirmPassword)),
            }).then(res => {
              if(res.success) {
                sessionStorage.clear()
                this.toNext()
              }
            })
          }
        })
      },
    }
  }
</script>


<style lang="scss" scoped>
  .panel-v2 {
    .right_icon {
      width: 24px;
      height: 24px;
      vertical-align: middle;
      margin-top: 7px;
      cursor: pointer;
    }
    .title {
      width: 100%;
      font: normal normal normal 20px/24px Nunito-bold;
      letter-spacing: 0px;
      color: #2E2E2E;
    }

    .sub-title {
      margin: 24px 0 0;
      font: normal normal normal 16px/24px Nunito;
      letter-spacing: 0px;
      color: #2E2E2E;
    }

    .link {
      margin: 48px 0 0;
      font: normal normal normal 16px/24px Nunito-bold;
      letter-spacing: 0px;
      color: #0072D8;
    }

    .el-button {
      margin: 12px 0 0;
      width: 100%;
    }
    
  }


</style>
